import Logo from './pics/Logo_White-03.svg'; 
import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, doc, setDoc } from 'firebase/firestore'
import { getAuth } from "firebase/auth";

// Connect to current firebase project
const firebaseApp = initializeApp({
    apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
    authDomain: "ambient-systems.firebaseapp.com",
    databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "ambient-systems",
    storageBucket: "ambient-systems.appspot.com",
    messagingSenderId: "1001740093061",
    appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
  });
const firestore = getFirestore(firebaseApp);

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');
const uid = window.localStorage.getItem('uid');

const mdTheme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        default: '#031c4a',
        paper: '#031c4a',
      },
      error: {
        main: '#060c43',
      },
      warning: {
        main: '#00e676',
      },
      success: {
        main: '#ffb74d',
      },
    },
  });

const auth = getAuth();

export default function OnboardPage() {
    const navigate = useNavigate();
    if(!user_email) navigate("/");

    const [show1, setShow1] = useState(true)
    const [show2, setShow2] = useState(false)
    const [show3, setShow3] = useState(false)

    const [firstName, setFirstName] = useState([])
    const [lastName, setLastName] = useState([])
    const [country, setCountry] = useState([])
    const [phoneNumber, setPhoneNumber] = useState([])
    const [goal, setGoal] = useState([])
    const [role, setRole] = useState([])

    /* Handle personal data uploading */
    const onSubmit = () => {
        if (firstName == "" || lastName == "" || country == "" || phoneNumber == "" || goal == "" || role == "") {
            alert("Please complete all the question!")
        } else {
            const userCredentials = {
                firstName: firstName,
                lastName: lastName,
                username: user_email,
                phoneNumber: phoneNumber,
                country: country,
                email: user_email,
                createdAt: new Date().toISOString(),
                userId: uid,
                goal: goal,
                role: role,
                isUpgrade: false
            }
            const userRef = doc(firestore, 'users/'+user_email)
            setDoc(userRef, userCredentials)
            alert("Completed! Thank you, now let's start!")
            navigate('/Dashboard/Welcome')
        }
    }

    const next1 = () => {
        setShow1(false)
        setShow2(true)
    }

    const next2 = () => {
        setShow2(false)
        setShow3(true)
    }

    const previous1 = () => {
        setShow1(true)
        setShow2(false)
    }
    
    const previous2 = () => {
        setShow2(true)
        setShow3(false)
    }

    return (
        <ThemeProvider theme={mdTheme}>
            <Box sx={{ display: 'flex' }}>
            <CssBaseline />
                <Box sx={{ height: "100vh", width: "100%", pt: 5, pl: 8 }}>
                    {/* Welcome title */}
                    {show1 && 
                        <Paper sx={{ display: 'flex', minWidth: 700, minHeight: 680 }}>
                            <Box>
                                <Box sx={{ minHeight: 60 }} />
                                <Box sx={{ maxWidth: 100, ml: '47%', mb: 3 }}>
                                    <LinearProgress variant="determinate" value={33} />
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h6"
                                        noWrap
                                        sx={{ ml: 8, mt: 3 }}
                                        style={{ fontWeight: 600 }}
                                    >
                                        Welcome to Ambientsystems!
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h7"
                                        noWrap
                                        color="#708090"
                                        sx={{ ml: 8, mt: 2 }}
                                    >
                                        Help us customize your experience by telling 
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h7"
                                        noWrap
                                        color="#708090"
                                        sx={{ ml: 8 }}
                                    >
                                        us a bit about yourself and your goal.
                                    </Typography>
                                </Box>

                                {/* Profile data */}
                                <Typography
                                    component="h1"
                                    variant="h7"
                                    noWrap
                                    sx={{ ml: "20%", mt: 4 }}
                                >
                                    Let's know you better:
                                </Typography>

                                <FormControl sx={{ ml: "25%", mt: 1 }}>
                                    <Box sx={{ mt: 3 }}>
                                        <TextField id="firstName" label="First Name" variant="standard" onChange={(e) => setFirstName(e.target.value)}/>
                                        <TextField id="lastName" label="Last Name" variant="standard" sx={{ ml: 5 }} onChange={(e) => setLastName(e.target.value)}/>
                                    </Box>

                                    <Box sx={{ mt: 3 }}>
                                        <TextField id="country" label="Country" variant="standard" onChange={(e) => setCountry(e.target.value)}/>
                                        <TextField id="phoneNumber" label="Phone Number" variant="standard" sx={{ ml: 5 }} onChange={(e) => setPhoneNumber(e.target.value)}/>
                                    </Box>

                                    <Box sx={{ mt: 5 }}>
                                        <TextField id="email" label="Email Address" variant="standard" defaultValue={user_email}
                                            InputProps={{
                                                readOnly: true,
                                        }}/>
                                    </Box>
                                </FormControl>

                                <Box sx={{ mt: 3, ml: 8, display: "flex" }}>
                                    <Button variant="contained" color='primary' component="label" sx={{ mt: 2, ml: 74 }} onClick={next1}>
                                        next
                                    </Button>
                                </Box>
                            </Box>
                        </Paper>
                    }
                    {show2 &&
                        <Paper sx={{ display: 'flex', minWidth: 700, minHeight: 680 }}>
                            <Box>
                                <Box sx={{ minHeight: 60 }} />
                                <Box sx={{ maxWidth: 100, ml: '47%', mb: 3 }}>
                                    <LinearProgress variant="determinate" value={66} />
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h6"
                                        noWrap
                                        sx={{ ml: 8, mt: 3 }}
                                        style={{ fontWeight: 600 }}
                                    >
                                        Almost there..
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h7"
                                        noWrap
                                        color="#708090"
                                        sx={{ ml: 8, mt: 2 }}
                                    >
                                        Help us customize your experience by telling 
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h7"
                                        noWrap
                                        color="#708090"
                                        sx={{ ml: 8 }}
                                    >
                                        us a bit about yourself and your goal.
                                    </Typography>
                                </Box>

                                {/* Goal data */}
                                <Typography
                                    component="h1"
                                    variant="h7"
                                    noWrap
                                    sx={{ ml: "20%", mt: 4 }}
                                >
                                    What is your main goal?
                                </Typography>

                                <FormControl sx={{ ml: "20%", mt: 1 }}>
                                    <Box display='flex' sx={{ mt: 3 }}>
                                        <RadioGroup
                                            aria-labelledby="goal-radio-buttons-group-label1"
                                            defaultValue=""
                                            name="goal-radio-buttons-group1"
                                            onChange={(e) => setGoal(e.target.value)}
                                        >
                                            <FormControlLabel value="Achieve regulatory requirements" control={<Radio />} label="Achieve regulatory requirements" />
                                            <FormControlLabel value="Identify new decarbonization technologies" control={<Radio />} label="Identify new decarbonization technologies" />
                                            <FormControlLabel value="Find a consultancy" control={<Radio />} label="Find a consultancy" />
                                        </RadioGroup>
                                        <RadioGroup
                                            aria-labelledby="goal-radio-buttons-group-label2"
                                            defaultValue=""
                                            name="goal-radio-buttons-group2"
                                            onChange={(e) => setGoal(e.target.value)}
                                        >
                                            <FormControlLabel value="Evaluate scenarios" control={<Radio />} label="Evaluate scenarios" />
                                            <FormControlLabel value="Minimize my emissions" control={<Radio />} label="Minimize my emissions" />
                                            <FormControlLabel value="Achieve lower energy-intensity of my services" control={<Radio />} label="Achieve lower energy-intensity of my services" />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>

                                <Box sx={{ mt: 12, ml: 8, display: "flex" }}>
                                    <Button variant="contained" color='primary' component="label" sx={{ mt: 2, ml: 58 }} onClick={previous1}>
                                        previous
                                    </Button>
                                    <Button variant="contained" color='primary' component="label" sx={{ mt: 2, ml: 3 }} onClick={next2}>
                                        next
                                    </Button>
                                </Box>
                            </Box>
                        </Paper>
                    }
                    {show3 &&
                        <Paper sx={{ display: 'flex', minWidth: 700, minHeight: 680 }}>
                            <Box>
                                <Box sx={{ minHeight: 60 }} />
                                <Box sx={{ maxWidth: 100, ml: '47%', mb: 3 }}>
                                    <LinearProgress variant="determinate" value={99} />
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h6"
                                        noWrap
                                        sx={{ ml: 8, mt: 3 }}
                                        style={{ fontWeight: 600 }}
                                    >
                                        Let's get started!
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h7"
                                        noWrap
                                        color="#708090"
                                        sx={{ ml: 8, mt: 2 }}
                                    >
                                        Help us customize your experience by telling 
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Typography
                                        component="h1"
                                        variant="h7"
                                        noWrap
                                        color="#708090"
                                        sx={{ ml: 8 }}
                                    >
                                        us a bit about yourself and your goal.
                                    </Typography>
                                </Box>

                                {/* Goal data */}
                                <Typography
                                    component="h1"
                                    variant="h7"
                                    noWrap
                                    sx={{ ml: "20%", mt: 4 }}
                                >
                                    What is your role?
                                </Typography>

                                <FormControl sx={{ ml: "47%", mt: 1 }}>
                                        <RadioGroup
                                            aria-labelledby="roal-radio-buttons-group-label"
                                            defaultValue=""
                                            name="roal-radio-buttons-group"
                                            onChange={(e) => setRole(e.target.value)}
                                        >
                                            <FormControlLabel value="Finance" control={<Radio />} label="Finance" />
                                            <FormControlLabel value="Marketing" control={<Radio />} label="Marketing" />
                                            <FormControlLabel value="Operations" control={<Radio />} label="Operations" />
                                            <FormControlLabel value="Development" control={<Radio />} label="Development" />
                                        </RadioGroup>
                                </FormControl>

                                <Box sx={{ mt: 11, ml: 8, display: "flex" }}>
                                    <Button variant="contained" color='primary' component="label" sx={{ mt: 2, ml: 58 }} onClick={previous2}>
                                        previous
                                    </Button>
                                    <Button variant="contained" color='primary' component="label" sx={{ mt: 2, ml: 3 }} onClick={onSubmit}>
                                        submit
                                    </Button>
                                </Box>
                            </Box>
                        </Paper>
                    }
                </Box>

                <Box sx={{ height: "100vh", width: "75%", pt: 5 }}>
                    <img id="backgroundImg" src={Logo} alt="Logo" style={{ opacity: 0.2 }} />
                </Box>
            </Box>
        </ThemeProvider>
    );
}